// @Version: 1.0.0
export enum FC_NUMBER {
   NUMBER = "number"
}

export enum SEARCH {
   DECIMAL = "decimal:",
   REPLACE = "#REPLACE#"
}

export enum PATTERN {
   NUMBER = "^-?[0-9]*$"
}